<ion-content class="wizard-options ion-padding">
  <div class="wizard-container">
    <div class="content-top">
      <div
        class="modal-header"
        [ngClass]="{ 'modal-header-ios': platform === 'ios' }"
      >
        <h3 class="title">{{ "venta-rapida.title" | translate }}</h3>
        <button
          type="button"
          class="close-button"
          (click)="close()"
          aria-label="Cerrar modal"
        >
          <ion-icon name="close" class="close-icon" />
        </button>
      </div>

      @if (currentStep() > 1) {
      <div class="breadcrumb">
        <span class="breadcrumb-label">
          {{ "venta-rapida.breadcrumb.for" | translate }}:
          <strong>{{ breadcrumbLabel() }}</strong>
        </span>
        <button
          type="button"
          class="breadcrumb-reset"
          (click)="resetSelection()"
          aria-label="Cambiar asistente"
        >
          <ion-icon name="close-circle-outline" />
        </button>
      </div>
      } @if (currentStep() === 1) {
      <app-venta-rapida-search-step
        [eventId]="eventId"
        (userSelected)="onUserSelected($event)"
        (anonymousChosen)="onAnonymousChosen($event)"
      />
      } @if (currentStep() === 2) {
      <app-venta-rapida-product-step
        [products]="products"
        (productSelected)="onProductSelected($event)"
      />
      } @if (currentStep() === 3 && selectedProduct(); as product) {
      <app-venta-rapida-price-step
        [product]="product"
        [submitting]="submitting()"
        (generate)="onGenerate($event)"
      />
      }
    </div>

    @if (currentStep() === 1) {
    <div class="wizard-footer">
      <app-main-button
        [label]="'venta-rapida.search.anonymous-shortcut'"
        (clicked)="onAnonymousChosen({ kind: 'full-anonymous' })"
      />
    </div>
    }
  </div>
</ion-content>
